// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h3d3","footer":"styles_footer__1V-C5","passCodeTooltip":"styles_passCodeTooltip__1QJEt"};